<template lang="html">
    <div id="page__transfer__toolbar" style="flex-grow: 3" class="report-forward-search tollbar__search">
        <div class="text">
            <span> Для печати отчёта укажите параметры фильтрации </span>
        </div>
        <z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light v-on:click="onReset"  v-bind:disabled="!hasFilter"></z-icon-button>
        <z-icon-button v-bind:icon="['fa', 'gear']" rounded v-on:click="toggleFilter" primary-light  v-bind:disabled="!hasFilter"></z-icon-button>
        <div v-if="visibility" v-click-outside="hideFilter" class="md-elevation-2 dropdown">
            <div class="search-md-menu-container">
                <div class="filter-container md-layout">

                    <div class="center-layout md-size-20 md-layout-item"> <label> Дата от </label> </div>

                    <div class="center-layout with-pr center-layout md-size-80 md-layout-item">
                        <z-date v-model="filter.date_from" no-margin v-bind:return-string="false" format="DD.MM.YYYY" type="date" placeholder="Дата от"> </z-date>
                    </div>

                    <div class="center-layout md-size-20 md-layout-item"> <label> Дата до </label> </div>
                    <div class="center-layout with-pr center-layout md-size-80 md-layout-item">
                        <z-date v-model="filter.date_to" no-margin v-bind:return-string="false" format="DD.MM.YYYY" type="date" placeholder="Дата до"> </z-date>
                    </div>
                    <div class="center-layout md-size-20 md-layout-item"> <label> Водитель  </label> </div>
                    <div class="center-layout with-pr md-size-80 md-layout-item">
                        <z-select v-model="filter.user_id">
                            <option value="" selected> Любой </option>
                            <option v-for="user in users" v-bind:value="user.id" v-bind:key="('user-' + user.id)"> {{user.label}} </option>
                        </z-select>
                    </div>

                    <div class="center-layout center-layout md-size-20 md-layout-item"> <label> Статус </label> </div>
                    <div class="center-layout with-pr md-size-80 md-layout-item">
                        <z-select v-model="filter.status_id">
                            <option v-bind:value="null"> Любой </option>
                            <option v-for="status in statuses" v-bind:value="status.id" v-bind:key="('status-' + status.id)"> {{status.label}} </option>
                        </z-select>
                    </div>
                    <div class="center-layout md-size-20 md-layout-item">
                        <label> Склад отправления </label>
                    </div>
                    <div class="center-layout with-pr md-size-80 md-layout-item">
                        <multy-autocomplete
                            placeholder="Склад"
                            display-property="name"
                            property="name"
                            return="id"
                            v-bind:show-search-input="false"
                            v-model="selectedFromStocks"
                            v-bind:showOnFocus="true"
                            v-bind:items="stocks"
                            id="report_filter_from_stock_id"
                            name="report_filter_from_stock_id"
                        ></multy-autocomplete>
                    </div>
                    <div class="center-layout md-size-20 md-layout-item">
                        <label> Склад Назначения </label>
                    </div>
                    <div class="center-layout with-pr md-size-80 md-layout-item">
                        <multy-autocomplete
                            placeholder="Склад"
                            display-property="name"
                            property="name"
                            return="id"
                            v-bind:show-search-input="false"
                            v-model="selectedToStocks"
                            v-bind:showOnFocus="true"
                            v-bind:items="stocks"
                            id="report_filter_to_stock_id"
                            name="report_filter_to_stock_id"
                        ></multy-autocomplete>
                    </div>
                    <div class="center-layout md-size-20 md-layout-item"> <label> НДС </label> </div>
                    <div class="center-layout with-pr md-size-80 md-layout-item">
                        <z-select v-model="filter.nds">
                            <option value="" selected> Любой </option>
                            <option v-bind:value="1"> с НДС </option>
                            <option v-bind:value="2"> без НДС </option>
                        </z-select>
                    </div>
                    <div class="center-layout md-size-20 md-layout-item"> <label> Маршрутные листы </label> </div>
                    <div class="center-layout with-pr md-size-80 md-layout-item">
                        <ZInputMultyValue v-model="filter.ids" id="rl-ids" name="rl-ids" value-type="number" placeholder="№ маршрутного листа"></ZInputMultyValue>
                    </div>

                    <div class="center-layout md-size-100 md-layout-item"> Внимание! При указании маршрутных листов остальные фильтры будут игнорироваться! </div>

                    <div class="dropdown-button-container md-alignment-bottom-right md-size-100 md-layout-item">
                        <z-button v-on:click="doFilter" fit-content no-margin> Применить </z-button>
                    </div>
                </div>
            </div>  
        </div>
    </div>
</template>
<script>
    import ZSelect from '@/components/ZSelect'
    import ClickOutside from 'vue-click-outside'
    import ZDate from '@/components/ZDate'
    import ZInputAutocomplete from '@/components/ZInputAutocomplete';
    import MultyAutocomplete from '@/components/MultyAutocomplete';
    import ZInputMultyValue from '@/components/ZInputMultyValue';
    import ZIconButton from '@/components/ZIconButton.vue';
    import ZButton from '@/components/ZButton.vue';
    export default {
        components: { ZSelect, ZDate, MultyAutocomplete, ZInputAutocomplete, ZInputMultyValue, ZIconButton, ZButton },
        directives: {ClickOutside},
        data() {
            return {
                visibility: false,
                users: [],
                statuses: [
                    {id: 1, label: 'Создан'},
                    {id: 2, label: 'В работе'},
                    {id: 3, label: 'Машина принята'},
                    {id: 4, label: 'Выдан на перемещение'},
                    {id: 5, label: 'Выполнен'}
                ],
                selectedFromStocks: [],
                selectedToStocks: [],
                filter: {
                    date_from: null,
                    date_to: null,
                    type: null,
                    user_id: null,
                    status_id: null,
                    nds: null,
                    city_id: null,
                    city_label: null,
                    route_list_id: null,
                    from_stock_id: [],
                    to_stock_id: [],
                    ids: []
                },
                filterDefault: {
                    date_from: null,
                    date_to: null,
                    type: null,
                    user_id: null,
                    status_id: null,
                    nds: null,
                    city_id: null,
                    city_label: null,
                    route_list_id: null,
                    from_stock_id: [],
                    to_stock_id: [],
                    ids: []
                },
            }
        },
        created() {
            this.init();
            this.getDrivers();
            if (this.$route.query && this.$route.query.custom_filter)
                this.filter = Object.assign({}, JSON.parse(this.$route.query.custom_filter));
        },
        computed: {
            hasFilter() {
                return Object.values(this.filter).find(item => !!item);
            },
            /**
             * Список складов
             */
            stocks() {
                return (this.$store.state.stock && this.$store.state.stock.stocks) ? this.$store.state.stock.stocks : [];
            },
        },
        watch: {
            'filter.type'() {
                this.clearCity();
            },
            'selectedFromStocks'(value) {
                if (value) this.filter.from_stock_id = value.map(item => item.id);
                else this.filter.from_stock_id = [];
            },
            'selectedToStocks'(value) {
                if (value) this.filter.to_stock_id = value.map(item => item.id);
                else this.filter.to_stock_id = [];
            }
        },
        methods: {
            /**
             * Инициализация компонента
             */
            init() {
                this.filter.date_from = this.moment().tz(this.$root.userTimezone).subtract(1,'months').startOf('month').toDate();
                this.filter.date_to   = this.moment().tz(this.$root.userTimezone).subtract(1,'months').endOf('month').toDate();
                this.filter.status_id = 5; //Статус по умолчанию - "Выполнен"
                this.doFilter();
                this.getStocks().then(() => this.getStocksFromFilter());
            },
            /**
             * Получение складов из фильтнра
             */
            getStocksFromFilter() {
                this.selectedFromStocks = this.stocks.filter(stock => this.filter.from_stock_id.indexOf(stock.id)+1);
                this.selectedToStocks   = this.stocks.filter(stock => this.filter.to_stock_id.indexOf(stock.id)+1);
            },
            /**
             * Скрыть фильтр
             */
            hideFilter() {
                this.visibility = false;
            },
            /**
             * Переключение фильтра
             */
            toggleFilter() {
                this.visibility = !this.visibility;
            },
            /**
             * Сброс фильтра
             */
            onReset() {
                this.filter = Object.assign({}, this.filterDefault);
                this.init();
                this.doFilter();
            },
            /**
             * Применение фильтра
             */
            doFilter() {
                this.$nextTick(() => {
                    let query = Object.assign({}, this.$route.query);
                    if (!query) query = {};
                    query.custom_filter = JSON.stringify(Object.assign({}, this.filter));
                    this.$router.push({ name: this.$route.name, params: this.$route.params, query: query});
                    this.$root.$emit('refresh-table', 'report-transfer');
                    this.hideFilter();
                });
            },
            /**
             * Очистка города
             */
            clearCity() {
                this.filter.city_id = null;
                this.filter.city_label = null;
            },
            /**
             * Выбор города
             */
            selectCity(id, city) {
                this.filter.city_id    = city.value;
                this.filter.city_label = city.label;
            },
            /**
             * Получение городов
             */
            getCities(value) {
                if (!value || value.length < 3) return new Promise(resolve => resolve([]));
                let filter = {model: [['name', '%', value]]};
                return this.$store.dispatch('cost/getCitiesNew', {page: 1, order_by: 'name', order_type: 'asc', count: 20, filter: filter}).then(result => {
                    if (!result || !result.data) return [];
                    return result.data.map(city => {
                        city.value = city.id;
                        city.label = city.name;
                        return city;
                    });
                });
            },
            /**
             * Получение складов
             */
            getStocks() { //получение всех складов
                return this.$store.dispatch('stock/getStocks', {page: 1, order_by: 'id', order_type: 'asc', count: 100});
            },
            /**
             * Получение водителей
             */
            getDrivers() {
                if (this.users && this.users.length) return new Promise(resolve => resolve(this.users));
                return this.$store.dispatch('users/getUsers', {page: 1, order_by: 'id', order_type: 'asc', count: 'all', filter: {
                    model: [], relation: [['groups', 'code', '=', ['driver']]], condition: 'and'
                }}).then(users => {
                    this.users = Object.assign([], []);
                    if (!users || !Array.isArray(users)) return [];

                    users.map(user => {
                        let groups = (user && user.groups && user.groups.length) ? user.groups.map(group => group.name) : []; 
                        this.users.push({
                            id: user.id,
                            label: (user.fio ? user.fio : user.login) + (groups ? ' (' +  groups.join(',') + ')' : '')
                        });
                    });

                    return users;
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// TransferToolbar.vue?d11469f2